import React from 'react'
import { Button, Image } from 'antd'
import { Link } from 'react-router-dom'
import { ArrowRightOutlined } from '@ant-design/icons'
import appstore from '../assets/images/appstore.png'
import playstore from '../assets/images/playstore.png'

type CustomButtonProps = {
  style?: any,
  children?: any,
  className?: string,
  childClass?: string,
  parentClass?: string,
  onClick?: () => void,
}
export function CustomButton({
  style,
  onClick,
  children, 
  className,
  childClass,
  parentClass,
}: CustomButtonProps) {
  return (
    <span onClick={onClick} style={style} className={'w-auto rounded-3xl p-px bg-gradient-to-l from-secondary to-primary '.concat(className!, " ", parentClass!)}>
      {children || (
        <div className={'rounded-3xl '.concat(className!, " ", childClass!)}></div>
      )}
    </span>
  )
}



type ArrowButtonProps = {
  path?: string,
  label?: string,
  children?: any,
  className?: string,
  onClick?: () => void,
}
export function ArrowButton({
  path,
  label,
  onClick,
  className,
}: ArrowButtonProps) {
  return (
    <CustomButton className={className!} onClick={onClick}>
      <Button href={path} className='text-sm font-medium hover:!text-dark' size='large' shape='round' iconPosition='end' icon={<ArrowRightOutlined className='p-1.5 bg-dark text-white !text-xs rounded-full' />}>{label}</Button>
    </CustomButton>
  )
}


type StoreButtonProps = {
  imgClass?: string,
  className?: string,
}
export default function StoreButton({ className, imgClass }: StoreButtonProps) {
  return (
    <div className={'grid grid-cols-2 gap-3 md:gap-5 '.concat(className!)}>
      {[
        { key: "playstore", label: "play store", image: playstore, path: "https://play.google.com/store/apps/details?id=com.paydat.app_andriod" },
        { key: "appstore", label: "app store", image: appstore, path: "#" },
      ].map(({key, label, image, path}) => (
        <a key={key} href={path} target='_blank' rel='noopener noreferrer' className='block'>
          <Image className={'w-full '.concat(imgClass!)} src={image} alt={label} preview={false} />
        </a>
      ))}
    </div>
  )
}
